import { render, staticRenderFns } from "./Agent-form.vue?vue&type=template&id=631c1e93"
import script from "./Agent-form.vue?vue&type=script&lang=js"
export * from "./Agent-form.vue?vue&type=script&lang=js"
import style0 from "./Agent-form.vue?vue&type=style&index=0&id=631c1e93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports